import type { FormatMarkerData } from "./dataset-cartesian-editor.type";
import type { AssetDetail } from "@/entities/asset";
import type { DatasetCartesian } from "@/entities/dataset";

export const formatMarkerData: FormatMarkerData = (
  coordinate_x,
  coordinate_y,
  coordinate_z
) => `${coordinate_x},${coordinate_y},${coordinate_z}`;

export const getDefaultMarkerStyle = (dataset?: DatasetCartesian) => {
  return dataset?.data
    ? {
        left: dataset.data.split(",")[0]
          ? `${100 * Number(dataset.data.split(",")[0])}%`
          : "",
        top: dataset.data.split(",")[1]
          ? `${100 * Number(dataset.data.split(",")[1])}%`
          : "",
        depth: dataset.data.split(",")[2]
          ? `${100 * Number(dataset.data.split(",")[2])}%`
          : "", // Not used
      }
    : undefined;
};

export const getImageUrl = (
  dataset?: DatasetCartesian,
  asset?: AssetDetail
) => {
  return dataset?.source_url ?? asset?.cartesian_image?.url ?? "";
};

export const getClickMarkerStyle = (coordinates: {
  coordinate_x: number;
  coordinate_y: number;
  coordinate_z: number;
}) => {
  const { coordinate_x = 0, coordinate_y = 0, coordinate_z = 0 } = coordinates;
  return {
    left: `${100 * coordinate_x}%`,
    top: `${100 * coordinate_y}%`,
    depth: `${100 * coordinate_z}%`,
  };
};
